{
    "m3WorkflowBuilder": {
        "title": "M3 Workflow Builder",
        "subtitle": "Välj program och transaktion för att visa metadata",
        "connection": "Anslutning",
        "connectionPlaceholder": "Välj en anslutning...",
        "program": "Program",
        "programPlaceholder": "Sök och välj ett program...",
        "programCount": "{count} program",
        "transaction": "Transaktion",
        "transactionPlaceholder": "Sök och välj en transaktion...",
        "inputFields": "Inmatningsfält",
        "outputFields": "Utmatningsfält",
        "fieldCount": "{count} fält",
        "fieldName": "Namn",
        "fieldDescription": "Beskrivning",
        "fieldType": "Typ",
        "fieldLength": "Längd",
        "fieldMandatory": "Obligatorisk",
        "required": "Obligatorisk",
        "noInputFields": "Inga inmatningsfält",
        "noOutputFields": "Inga utmatningsfält",
        "createWorkflow": "Skapa arbetsflöde",
        "workflowName": "Arbetsflödesnamn",
        "workflowNamePlaceholder": "Ange arbetsflödesnamn",
        "create": "Skapa",
        "creating": "Skapar...",
        "workflowCreated": "Skapad",
        "workflowCreatedSuccess": "Arbetsflöde skapat!",
        "workflowId": "Arbetsflödes-ID",
        "workflowCreateFailed": "Kunde inte skapa arbetsflöde",
        "runWorkflow": "Kör arbetsflöde",
        "runInfo": "Arbetsflödet kan nu användas av App Builder. Om du vill kan du testa det nedan.",
        "run": "Kör arbetsflöde",
        "running": "Kör...",
        "workflowResult": "Arbetsflödesresultat",
        "recordCount": "{count} post(er)",
        "noRecords": "Inga poster returnerade",
        "error": "Fel",
        "field": "Fält",
        "loadConnectionsError": "Kunde inte ladda anslutningar",
        "loadProgramsError": "Kunde inte ladda program",
        "loadTransactionsError": "Kunde inte ladda transaktioner",
        "loadFieldsError": "Kunde inte ladda transaktionsfält",
        "createWorkflowError": "Kunde inte skapa arbetsflöde",
        "runWorkflowError": "Kunde inte köra arbetsflöde",
        "menuLabel": "M3 Workflow Builder"
    }
}
